// extracted by mini-css-extract-plugin
export default {"videoCard":"VideoCard_videoCard__pLMoR","info":"VideoCard_info__-CzGF","title":"VideoCard_title__s9gtZ","name":"VideoCard_name__QmUFU","time":"VideoCard_time__vxw1c"};